import { useEffect } from 'react';
import './Header.scss';
import FeatureTab from '../FeatureTab';
import { useDispatch, useSelector } from 'react-redux';
import { apiPost } from 'services/api.service';
import Logo from 'assets/images/logo-full.svg';
import {
	APP_ENDPOINT_FETCH_VEHICLELIST,
	APP_ENDPOINT_FETCH_GROUPLIST,
} from 'services/APIConstants';

// Import action creators instead of action types
import {
	updateVehicleList,
	setAllVehicles,
	updateMyGroup,
	setDashboardLoaded,
	updateTripReportData,
	updateChargeTrackerDataLive,
	updateChargeTrackerData,
	updateTripInsightData,
} from 'app/config/Redux/global.reducer'; // Adjust this path to where your reducers are
import { useNavigate } from 'react-router';

function Header() {
	const dispatch = useDispatch();
	const dashboardLoaded = useSelector((state) => state.dashbaordLoaded);
	let navigate = useNavigate();

	useEffect(() => {
		window.IntellicarSSOWidget.default.renderProfileSettings('intellicarSSODropWidget', {
			onSignedIn,
			onLoggedOut,
		});
	}, []);

	const mergeGroup = (treeRaw) => {
		let tree = {};
		let checkedGroup = null;
		let byLevel = {};
		let level;
		let highestLevel = 0;
		let lowestLevel = 1000;

		for (let idx in treeRaw) {
			level = treeRaw[idx].path.split('/').length - 2;
			if (level > highestLevel) highestLevel = level;
			if (level < lowestLevel) lowestLevel = level;
			if (!(level in byLevel)) {
				byLevel[level] = {};
			}
			if (!checkedGroup) {
				treeRaw[idx].checked = true;
			}
			for (let cdx in checkedGroup) {
				if (checkedGroup[cdx].path === treeRaw[idx].path) {
					treeRaw[idx].checked = true;
				}
			}
			treeRaw[idx].children = [];
			byLevel[level][treeRaw[idx].path] = treeRaw[idx];
		}

		let children = [];

		for (let idx = highestLevel; idx > lowestLevel; idx--) {
			if (byLevel[idx - 1]) {
				for (let jdx in byLevel[idx]) {
					if (byLevel[idx][jdx].ppath in byLevel[idx - 1]) {
						byLevel[idx][jdx].hasParent = true;
						byLevel[idx - 1][byLevel[idx][jdx].ppath].children.push(byLevel[idx][jdx]);
					} else {
						children.push(byLevel[idx][jdx]);
					}
				}
			}
		}

		if (Object.keys(byLevel).length > 0) {
			for (let idx in byLevel[lowestLevel]) {
				byLevel[lowestLevel][idx].expanded = true;
				children.push(byLevel[lowestLevel][idx]);
			}
			children.push({
				name: 'Users',
				checked: true,
				groupid: 0,
			});

			tree = {
				children,
				name: 'Groups',
				checked: true,
				groupid: 0,
				expanded: true,
			};
		}
		return tree;
	};

	const mergeVehicleWithGroup = (treeRaw) => {
		let tree = mergeGroup(treeRaw);
		dispatch(updateMyGroup(tree));
	};

	const loadGroup = async () => {
		let treeRaw = [];
		const myGroup = await apiPost(APP_ENDPOINT_FETCH_GROUPLIST, {});
		window.userGroups = myGroup.data;
		treeRaw = myGroup.data;

		if (myGroup) {
			let treeRawMap = {};
			for (let idx in treeRaw) {
				treeRawMap[treeRaw[idx].groupid] = treeRaw[idx];
			}
			let patharr;
			for (let idx in treeRaw) {
				treeRaw[idx].groupnamepath = '';
				patharr = treeRaw[idx].path.split('/');
				for (let jdx in patharr) {
					if (treeRawMap[patharr[jdx]]) {
						treeRaw[idx].groupnamepath += '/' + treeRawMap[patharr[jdx]].name;
					}
				}
			}
			window.treeRawMap = treeRawMap;
			mergeVehicleWithGroup(treeRaw);
		}
	};

	const loadAllDependencies = async () => {
		// console.log('here');
		const vehicles = await apiPost(APP_ENDPOINT_FETCH_VEHICLELIST, {});
		// console.log(vehicles, 'vehicles frm header');
		await dispatch(updateVehicleList(vehicles.data));
		await dispatch(setAllVehicles(vehicles.data));
		loadGroup();
		dispatch(setDashboardLoaded(true));
	};

	const handleClearCacheApp = () => {
		// Clear trip report redux
		dispatch(updateTripReportData(null));
		// Clear chargetracker data redux
		dispatch(updateChargeTrackerDataLive(null));
		dispatch(updateChargeTrackerData(null));
		// Clear trip insight redux
		dispatch(updateTripInsightData(null));
		// Finally clear sessionStorage
		sessionStorage.clear();
	};

	const onSignedIn = () => {
		if (!dashboardLoaded) {
			loadAllDependencies();
			handleClearCacheApp();
		}
	};

	const onLoggedOut = () => {
		navigate('/');
	};

	return (
		<div className="Header">
			<div className="LeftContent">
				<div className="ImgContainer">
					<img alt="Logo" src={Logo} />
				</div>
				<FeatureTab />
			</div>

			<div className="RightContent">
				<div id="intellicarSSODropWidget"></div>
			</div>
		</div>
	);
}

export default Header;
